/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useCallback, useState } from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import ImageViewer from 'react-simple-image-viewer';
import { IPostViewModel } from 'viewModels';
import { UserProfilePicture } from '../../UserProfilePicture';
import { PostType } from '../../../types/enums';
import MapSearch from '../../MapSearch';
import { Container } from './styles';
import { API_BASE_URL } from '../../../config/apiConfig';

interface PublicationProps {
  post: IPostViewModel;
  margin?: string;
}
export function Publication({ post, margin }: PublicationProps) {
  const differenceInMilliseconds = new Date().getTime() - new Date(post.createdAt).getTime();
  const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  const differenceInHours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
  const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));
  const [currentIdxAttachment, setCurrentIdxAttachment] = useState(0);
  const [isOpenViewer, setIsOpenViewer] = useState(false);

  const handleOpenImageViewer = useCallback((index: number) => {
    setCurrentIdxAttachment(index);
    setIsOpenViewer(true);
  }, []);

  const handleCloseImageViewer = () => {
    setCurrentIdxAttachment(0);
    setIsOpenViewer(false);
  };
  return (
    <Container
      columnsContainerUp={post.attachments?.slice(0, 2).length}
      columnsContainerDown={post.attachments?.slice(2, 5).length}
      margin={margin}>
      <div className="header">
        <div className="header-dados">
          <UserProfilePicture pictureId={post?.createdBy?.profilePictureId} />
          <div className="information">
            <p className="name">{`${post?.createdBy?.firstName} ${post?.createdBy?.lastName}`}</p>
            <div className="time">
              <span className="most-information">
                {differenceInDays > 0
                  ? `${differenceInDays} d`
                  : differenceInHours > 0
                  ? `${differenceInHours} h`
                  : `${differenceInMinutes} m`}{' '}
                ●
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="publication">
        {post.body && (
          <div className="description">
            <p className="description-text">{post.body}</p>
          </div>
        )}
        {post.attachments && post.attachments.length > 0 && (
          <div className="content">
            <div className="post">
              <div className="containerUp">
                {post.attachments?.slice(0, 2).map(({ id, url }, index) => (
                  <img
                    key={id}
                    src={url || `${API_BASE_URL}/file/?id=${id}`}
                    alt="Imagem da publicação"
                    loading="lazy"
                    onClick={() => handleOpenImageViewer(index)}
                  />
                ))}
              </div>
              <div className="containerDown">
                {post.attachments?.slice(2, 5).map(({ id, url }, index) => (
                  <div key={id} className="containerPost">
                    <img
                      src={url || `${API_BASE_URL}/file/?id=${id}`}
                      alt="Imagem da publicação"
                      loading="lazy"
                      onClick={() => handleOpenImageViewer(index + 2)}
                    />
                  </div>
                ))}
                {post.attachments?.length > 5 && (
                  <div
                    role="presentation"
                    className="more"
                    onClick={() => handleOpenImageViewer(4)}>
                    <p>{`+${post.attachments.length - 5}`}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {post.type === PostType.LOCATION && post.latitude && post.longitude && (
          <div className="location">
            <MapSearch
              action="view-place"
              center={{
                lat: post.latitude,
                lng: post.longitude,
              }}
              key={post.id}
              options={{
                zoom: 16,
                changeMarkerWhenPanChange: false,
                zoomControl: true,
                draggable: true,
              }}
            />
          </div>
        )}
      </div>
      {isOpenViewer && post.attachments && (
        <ImageViewer
          src={post.attachments.map(({ id, url }) => url || `${API_BASE_URL}/file/?id=${id}`)}
          currentIndex={currentIdxAttachment}
          disableScroll={false}
          closeOnClickOutside
          onClose={handleCloseImageViewer}
          backgroundStyle={{
            backgroundColor: 'rgba(0,0,0,0.9)',
            zIndex: 9999,
          }}
        />
      )}
    </Container>
  );
}
